var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "columns is-mobile is-gapless is-fullheight" },
    [
      _c("transition", { attrs: { name: "sidebar" } }, [
        _c(
          "aside",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.state.visibleSidebar,
                expression: "$store.state.visibleSidebar",
              },
            ],
            staticClass: "column is-narrow aside hero sidebar",
          },
          [_c("sidebar")],
          1
        ),
      ]),
      _c("transition", { attrs: { name: "sidebar-replace" } }, [
        _c("aside", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.visibleSidebar,
              expression: "$store.state.visibleSidebar",
            },
          ],
        }),
      ]),
      _c(
        "div",
        {
          staticClass: "column overflow-hidden",
          attrs: { id: "site-wrapper" },
        },
        [
          _c(
            "main",
            { staticClass: "site-content" },
            [_c("navbar"), _c("router-view")],
            1
          ),
          _c("dash-footer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }